import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

interface DecisionLogButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const DecisionLogButton: React.FC<DecisionLogButtonProps> = ({
  onClick,
  disabled,
}) => {
  const button = (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size="medium"
    >
      <StickyNote2Icon />
    </IconButton>
  );

  return (
    <Tooltip title={disabled ? "Run AutoPark first to generate decision log" : "View Decision Log"}>
      <span>{button}</span>
    </Tooltip>
  );
};
